import moment from 'moment';
import axios from 'axios';

(function ($) {
  "use strict";
  $(function () {

    moment.locale('ru');

    class OrderTimerCountdown {
      constructor(instance) {
        this.block = instance;
        this.time = instance.data('time');
        this.hours = instance.find('[data-entity="hours"]');
        this.minutes = instance.find('[data-entity="minutes"]');
        this.seconds = instance.find('[data-entity="seconds"]');
        this.timerInstance = null;
        this.orderID = instance.data('order');
        this.run();
      }

      run() {
        this.timerInstance = setInterval(() => {
          if (this.time - 1 <= 0) {
            this.cancelOrder();
            return;
          }
          this.time = this.time - 1;
          this.hours.text(moment().startOf('day').seconds(this.time).format('HH'));
          this.minutes.text(moment().startOf('day').seconds(this.time).format('mm'));
          this.seconds.text(moment().startOf('day').seconds(this.time).format('ss'));

          if (this.time % 5 === 0) {
            this.checkStatus();
          }


        }, 1000);

      }

      disableTimer() {
        this.block.fadeOut(300);
        clearInterval(this.timerInstance);
        this.block.remove();
      }

      checkStatus() {
        let _self = this;
        $.ajax({
          dataType: 'json',
          url: '/ajax/getOrderState.php',
          data: {
            orderId: this.orderID
          },
          cache: false,
          success: function (data) {
            console.log(data);
            let result = data[0];
            if (result['statusCode'] !== 'N') {
              console.log('status code not N!');
              _self.disableTimer();
              if (result['statusCode'] === 'C') {
                _self.refresh();
              }
            }
          },
          error: function (data) {
            console.log(data)
          }
        });
      }

      refresh() {
        location.reload();
      }

      cancelOrder() {
        console.log('cancel');
        this.disableTimer();
        let _self = this;
        $.ajax({
          dataType: 'json',
          url: '/ajax/cancelOrder.php',
          data: {
            orderID: this.orderID
          },
          cache: false,
          success: function (data) {
            console.log(data);
            _self.refresh();
          },
          error: function (data) {
            console.log(data)
          }
        });
      }

    }

    let countdownInstance = $('[data-entity="order-payment-countdown"]');
    if (countdownInstance.length) {
      window.orderTimerCountdown = new OrderTimerCountdown(countdownInstance);
    }

    $(document).on('click', '[data-action="repeat-order"]', function () {
      $.ajax({
        dataType: 'json',
        url: '/ajax/repeatOrder.php',
        data: {
          id: $(this).data('order')
        },
        cache: false,
        success: function (data) {
          if (data['success']){
            window.location.href = '/personal/cart/';
          }
        },
        error: function (data) {
          console.log(data)
        }
      });
    });


  });
})(jQuery);
